/*
Created by: Sudheesh S
Created on: 06-09-2024
Page Description: This component implements a header navigation system for a dashboard.
It allows users to navigate between different pages, including a market page that loads content from an external site based on an API response.
The component dynamically fetches and embeds an external market-related page via an iframe when the user clicks on "Al Mal Capital Markets" in the header.
*/

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import callingAPI from "../service";
import IconArrowBack from "../images/previous.png";
import { useDispatch, useSelector } from "react-redux";
import { setDashboardData } from "../redux/reducers/dashboardSlice";


export default function Marketwatch() {
    const dispatch = useDispatch()
    const dashboardDetails = useSelector((state) => state.Dashboard);
    const [notificationDiv, setnotificationDiv] = useState(false);
    const [toggleMenu, setToggleMenu] = useState(false);
    const [active, setActive] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const [capitalMarketsUrl, setCapitalMarketsUrl] = useState('');
    const userId = dashboardDetails.userId
    const refreshToken = dashboardDetails.refreshToken;
    var userLogId = ""
    const clientId = dashboardDetails.clientid;

    useEffect(() => {
        if (!clientId) {
            navigate('/');
            return;
        }
        const currentPath = location.pathname.replace('/', '');
        setActive(currentPath);

        if (currentPath === "market") {
            fetchMarketData();
        }
    }, [location.pathname]);

    useEffect(() => {
        dispatch(
            setDashboardData({
                moduleId: 5,
                userlogId: ""
            })
        );
        handleUserLog()
        return () => {
            handleUserLog();
        };
    }, []);
    const handleUserLog = () => {
        const postData = {
            "userId": userId,
            "isApp": "false",
            "moduleId": 5,
            "previousPage": dashboardDetails.previousPage,
            "userSession": refreshToken,
            "userLogId": userLogId
        }
        callingAPI(postData, "user/userLog", 'post')
            .then((response) => {
                const { data } = response;
                if (data.statusCode === 200) {
                    userLogId = data.data.userLogId
                    dispatch(
                        setDashboardData({
                            previousPage: 5,
                        })
                    );
                }
                else {
                    userLogId = ""
                }
            })
            .catch((error) => {
                console.error('Error during profile fetch:', error);
            });
    }

    const fetchMarketData = () => {
        const clientId = dashboardDetails.clientid;
        const postData = {
            clientId: clientId,
            //"refreshToken": refreshToken,
            "userId": userId,
        };

        callingAPI(postData, "sso/entry", 'post')
            .then((response) => {
                const { data } = response;
                setCapitalMarketsUrl(data.data); // Set the URL when the API call is successful
            })
            .catch((error) => {
                console.error("Error fetching market data", error);
            });
    };
    const handleNavigation = () => {
        // localStorage.setItem("reportValue", "Dashboard")
        dispatch(
            setDashboardData({
                reportValue: "Dashboard",
                fromDate: new Date()
            }

            ))
        navigate("/dashboard", { state: { selectedDate: formattedDate, directFlag: true } })
    }
    const formattedDate = dashboardDetails.fromDate ? new Date(dashboardDetails.fromDate).toISOString().split('T')[0] : new Date().toISOString().split('T')[0];
    return (
        <div className="main-wrapper">
            <div className="back-btn" onClick={() => handleNavigation()}>
                {/* <IoMdArrowBack className="back-btn-icon"/> */}
                <img src={IconArrowBack} alt="" className="back-btn-icon" />
                <span className="back-btn-text"> Back To Dashboard</span>
            </div>
            {capitalMarketsUrl && (
                <div className="">
                    <div className="row m-0" style={{ height: "calc(100vh - 56px)" }}>
                        <iframe
                            src={capitalMarketsUrl}
                            title="Market Frame"
                            width="100%"
                            height="100%"
                            className="border-0"
                        ></iframe>
                    </div>
                </div>
            )}

        </div>
    );
}
